
/* injects from baggage-loader */

export const resetText = ['Você excedeu o <b>limite</b> de passos que nosso tamanduá poderia andar. <br> Ele está cansando, <b>tente novamente</b>.'];


// WEBPACK FOOTER //
// ./src/app/components/ui/tamandua-canvas/tamandua-canvas.const.js